<template>
    <div class="coverinvoicedetails">
        <span class="bloctitle">{{$t('Cover.RequestCover.INVOICE_DETAILS_SUB_TITLE')}}</span>
        <div class="divider">
            <v-divider></v-divider>
        </div>
        <br>
        <br>
        <v-layout row>
             <v-flex xs12>
                <div>
                     <v-text-field v-model="invoiceNumber" :label="$t('Cover.RequestCover.INVOICE_NUMBER_FIELD_NAME')" :placeholder="$t('Cover.RequestCover.INVOICE_NUMBER_PLACEHOLDER')" ></v-text-field>
                </div>
              </v-flex>
        </v-layout>
        <br>
        <v-layout row>
          <v-flex xs12>
            <CurrencyInputField v-model="invoiceValue" @input="validateForm" :label="$t('Cover.RequestCover.INVOICE_VALUE_FIELD_NAME') + ' *'" :placeholder="$t('Cover.RequestCover.INVOICE_VALUE_PLACEHOLDER')" :disabled="disableCurrency" :currencies="currencies" :currency="selectedCurrency" @selectedCurrencyChanged="selectedCurrencyChanged" backgroundColor="#ffffff" />
          </v-flex>
        </v-layout>
        <br>
        <v-layout row>
            <v-flex xs6>
                <div class="calendarleft">
                    <v-menu
                        ref="issueDateMenu"
                        v-model="issueDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                            v-model="issueDateFormatted"
                            :label="$t('Cover.RequestCover.ISSUE_DATE_FIELD_NAME')"
                            placeholder="DD/MM/AAAA"
                            prepend-icon="event"
                            readonly
                            @blur="date = parseDate(issueDateFormatted)"
                            v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="issueDate" no-title @input="issueDateMenu = false"></v-date-picker>
                    </v-menu>
                </div>
            </v-flex>
             <v-flex xs6>
                 <div class="calendarright">
                    <v-menu
                    ref="dueDateMenu"
                    v-model="dueDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                    >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                        v-model="dueDateFormatted"
                        :label="$t('Cover.RequestCover.DUE_DATE_FIELD_NAME')"
                        placeholder="DD/MM/AAAA"
                        readonly
                        prepend-icon="event"
                        @blur="date = parseDate(dueDateFormatted)"
                        v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker :min="minDueDate" v-model="dueDate" no-title @input="dueDateMenu = false"></v-date-picker>
                    </v-menu>
                 </div>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import CurrencyInputField from '@/components/common/CurrencyInputField'
export default {
  props: ['defaultCurrency', 'currencies', 'invoiceTransferredFromCover', 'disableCurrency'],
  components: {
    CurrencyInputField
  },
  data () {
    return {
      invoiceNumber: '',
      invoiceValue: '',
      selectedCurrency: {},
      issueDate: dayjs().format('YYYY-MM-DD'),
      issueDateFormatted: '',
      issueDateMenu: false,
      dueDate: dayjs().add(30, 'days').format('YYYY-MM-DD'),
      dueDateFormatted: '',
      dueDateMenu: false,
      minDueDate: dayjs().add(1, 'days').format('YYYY-MM-DD'),
      invoiceValueRegex: '^\\d+(\\.\\d{1,2})?$'
    }
  },
  mounted () {
    this.selectedCurrency = this.defaultCurrency
    this.issueDateFormatted = this.formatDate(this.issueDate)
    this.dueDateFormatted = this.formatDate(this.dueDate)
  },
  methods: {
    parseDate (date) {
      return this.$formatDateToUniversal(date)
    },
    formatDate (date) {
      return this.$formatDateFromUniversal(date)
    },
    initMode () {
      this.invoiceNumber = ''
      this.invoiceValue = ''
      this.issueDate = dayjs().format('YYYY-MM-DD')
      this.dueDate = dayjs().add(30, 'days').format('YYYY-MM-DD')
      this.issueDateFormatted = this.formatDate(this.issueDate)
      this.dueDateFormatted = this.formatDate(this.dueDate)
      this.issueDateMenu = false
      this.dueDateMenu = false
      this.selectedCurrency = this.defaultCurrency
      this.minDueDate = dayjs().add(1, 'days').format('YYYY-MM-DD')
    },
    validate () {
      var invoiceRegex = RegExp(this.invoiceValueRegex)
      return this.invoiceValue !== '' && !isNaN(parseFloat(this.invoiceValue)) && invoiceRegex.test(this.invoiceValue) && this.dueDateFormatted !== '' && this.issueDateFormatted !== ''
    },
    validateForm () {
      this.$emit('validateForm')
    },
    getSelectedInfos () {
      return {
        invoiceNumber: this.invoiceNumber,
        invoiceValue: this.invoiceValue,
        currency: this.selectedCurrency.currency,
        issueDate: dayjs(this.issueDate).format('YYYY-MM-DD'),
        dueDate: dayjs(this.dueDate).format('YYYY-MM-DD')
      }
    },
    selectedCurrencyChanged (value) {
      this.selectedCurrency = value
    }
  },
  watch: {
    issueDate (val) {
      const datediff = dayjs(this.dueDate).diff(val, 'days')
      if (datediff < 0) {
        this.dueDate = dayjs(val).add(1, 'day').format('YYYY-MM-DD')
      }
      this.minDueDate = dayjs(this.issueDate).add(1, 'day').format('YYYY-MM-DD')
      this.issueDateFormatted = this.formatDate(this.issueDate)
    },
    dueDate (val) {
      const datediff = dayjs(this.issueDate).diff(val, 'days')
      if (datediff > 0) {
        this.issueDate = dayjs(this.issueDate).subtract(1, 'day').format('YYYY-MM-DD')
      }
      this.dueDateFormatted = this.formatDate(this.dueDate)
    },
    invoiceTransferredFromCover (val) {
      if (val) {
        this.invoiceNumber = val.invoiceNumber
        this.invoiceValue = val.invoiceValue
        this.issueDate = this.parseDate(val.issueDate)
        this.dueDate = this.parseDate(val.dueDate)
        var invoiceCurrency = this.currencies.find(c => c.currency.toUpperCase() === val.currency.toUpperCase())
        if (invoiceCurrency) {
          this.selectedCurrencyChanged(invoiceCurrency)
        } else {
          this.selectedCurrency.currency = val.currency.toUpperCase()
        }
        this.validateForm()
        this.$emit('successfulInvoiceTransferOnDispose')
      }
    }
  },
  computed: {
    ...mapState('countries', ['currencyFlags']),
    ...mapState('userdetails', ['userInfos'])
  }
}
</script>
<style>
.bloctitle{
    font-size: 15px;
}

.coverinvoicedetails .v-input__slot {
  background-color: #ffffff  !important;
}
.currencySelector {
    height: 40px;
    background-color: #ffffff;
    margin-top: 18px;
    border: 1px solid #d4d9e1;
    border-left: 0px;
    border-bottom-right-radius : 5px !important;
    border-top-right-radius: 5px !important;
    width: 87px;
    cursor: pointer;
}
.currencyField {
    display: inline-flex;
    width: 100%;
}
.currencyText .v-input__slot {
  border-radius: 0px !important;
  border-bottom-left-radius: 5px !important;
  border-top-left-radius: 5px !important;
}
.currencyText {
    width: 100%
}
.selectorCurrencyContent{
    margin-left: 9px;
    margin-top: 9px;
    display: flex;
}
.v-date-picker-table .v-btn.v-btn--active {
    color: #090BEC;
}
.calendarleft {
    padding: 0px 10px 0px 0px;
}
.calendarright {
    padding: 0px 0px 0px 10px;
}
</style>
